<div class="contract-row-card card-wrapper">
    <div class="card">
        @if (appFacadeService.isContractSelectableAndAvailable(contract.contractId) | async) {
        <div class="head-top">
            <div class="checkbox">
                <por-base-checkbox
                    #check
                    [isChecked]="(appFacadeService.isContractAvailableInState(contract.contractId) | async) || params.value"
                    (checkboxChange)="onCheckboxChange($event)"></por-base-checkbox>
            </div>
        </div>
        }
        <ul>
            @for (item of contractKV; track item) {
            <li class="row">
                <div class="col-2">
                    <h5 class="title">{{ item.label | translate }}</h5>
                </div>
                <span>:</span>
                <div class="col-10">
                    <data>{{ item.value }}</data>
                </div>
            </li>
            }
        </ul>

        <por-base-button (onclick)="loadContractDetail()" [featureName]="'view-details'">{{ 'view details' | translate }}</por-base-button>
    </div>
</div>
